import { render, staticRenderFns } from "./MyLove.vue?vue&type=template&id=0b8a052e&"
import script from "./MyLove.vue?vue&type=script&lang=js&"
export * from "./MyLove.vue?vue&type=script&lang=js&"
import style0 from "./MyLove.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports